import React, { useState } from "react";
import { Grid, Step, Stepper, StepLabel, Box, Typography } from "@material-ui/core";
import { DPButton } from "Components/DP";
import useStyles from "./styles";
import { useEnterEmailStep } from "./EnterEmailStep/useEnterEmailStep";
import { useInformationAndPermissionsStep } from "./InformationAndPermissionsStep/useInformationAndPermissionsStep";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import { useConfirmationStep } from "./ConfirmationStep/useConfirmationStep";

export interface CreateManagerStepperProps {
  closeModal: () => void;
}

export interface CreateManagerState {
  existingEmployerId: string | null | undefined;
  formFields: OperatingManagerFormFields;
  activeStep: number;
}

const DEFAULT_CREATE_MANAGER_STATE: CreateManagerState = {
  existingEmployerId: undefined,
  formFields: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    locations: [],
    budget: "",
    permissions: null,
    secondaryApprovers: [],
  },
  activeStep: 0,
};

export const CreateManagerStepper = ({ closeModal }: CreateManagerStepperProps) => {
  const classes = useStyles();
  const [state, setState] = useState<CreateManagerState>(DEFAULT_CREATE_MANAGER_STATE);

  const handleNext = async () => {
    const newCompletedFields = await steps[state.activeStep].onComplete();
    if (newCompletedFields) {
      setState((prevState) => ({
        ...prevState,
        ...newCompletedFields,
      }));

      if (state.activeStep < steps.length - 1) {
        setState((prevState) => ({
          ...prevState,
          activeStep: prevState.activeStep + 1,
        }));
      } else {
        closeModal();
      }
    }
  };

  const handleBack = () => {
    setState((prevState) => ({
      ...prevState,
      activeStep: prevState.activeStep - 1,
    }));
  };

  const emailStep = useEnterEmailStep(state.formFields.email, handleNext);
  const informationAndPermissionsStep = useInformationAndPermissionsStep(state);
  const confirmationStep = useConfirmationStep(state.formFields, state.existingEmployerId);
  const steps = [
    emailStep,
    informationAndPermissionsStep,
    confirmationStep,
  ];

  return (
    <Box m={4}>
      <Typography variant="h2" align="center" >
        Create Operating Manager
      </Typography>
      <Stepper activeStep={state.activeStep}>
        {steps.map(({ label }) => (
          <Step key={label}>
            <StepLabel classes={{
              label: classes.label
            }}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {steps[state.activeStep].content}
      <Grid container justify="center">
        <DPButton disabled={state.activeStep === 0} onClick={handleBack} align="right" color="default">
          Back
        </DPButton>
        <DPButton
          onClick={closeModal}
          align="right"
          color="default"
        >
          Cancel
        </DPButton>
        <DPButton onClick={handleNext} align="right" type="submit">
          {state.activeStep < steps.length - 1 ? "Next" : "Submit"}
        </DPButton>
      </Grid>
    </Box>
  );
};
